import { Button } from '@/components/ui/button/button.component';
import { handleOpenSearchModal } from '@/store/search/handle-open-search-modal';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

export const FaqSearchButton = () => {
  return (
    <Button variant="secondary" onClick={() => handleOpenSearchModal()} data-analytics-event={AnalyticsEnum.CLICK_FAQ_SEARCH_AVAILABILITY_BUTTON}>
      Pesquisar disponibilidade
    </Button>
  );
};
